"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectContext = void 0;
const react_1 = require("react");
exports.SelectContext = react_1.createContext({});
exports.SelectContext.displayName = 'SelectContext';
